import { render } from "./TreatmentFilter.vue?vue&type=template&id=780eaaef"
import script from "./TreatmentFilter.vue?vue&type=script&lang=js"
export * from "./TreatmentFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__